export enum GameModeType {
	Hub = 'hub',
	Adventure = 'adventure',
	TestRealm = 'testRealm',
}
